import { TalentpoolService } from 'src/app/_services/talentpool.service';
import { CandidateService } from './../../_services/candidate.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AfterViewChecked, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Observable, Subject } from 'rxjs';
import _ from 'underscore';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchtoolboxService } from './../../_services/searchtoolbox.service';
import { GlobalService } from 'src/app/_services/global.service';
import { JobDescriptionModalComponent } from '../job-description-modal/job-description-modal.component';
import { TransactionService } from 'src/app/_services/transaction.service';
declare const clevertap;

@Component({
  selector: 'app-searchtoolbox-v2',
  templateUrl: './searchtoolbox-v2.component.html',
  styleUrls: ['./searchtoolbox-v2.component.scss']
})

export class SearchtoolboxV2Component implements OnInit, AfterViewChecked {
  totalSearchResultsCount: any;
  deselectedJobTitlesArray: any[] = [];
  deselectedSkillsArray: any[] = [];
  searchToolboxHistory: any[] = [];
  totalHistoryRecordsCount: any;
  total: any;
  start: number = 0;
  end: any;
  showSearchHistoryPage: boolean = false;
  showSearchPlatformPage: boolean = false;
  selectedPlatformType: string;
  tabToShow: string;
  filteredInstituteOption: Array<any> = [];
  institute: string[] = [];
  filteredSpokenLanguageOption: Array<any> = [];
  spokenLanguage: string[] = [];
  filteredProgrammingLanguageOption: Array<any> = [];
  programmingLanguage: string[] = [];
  filteredEducationalDegreeOption: Array<any> = [];
  educationalDegree: string[] = [];
  showSearchResults: boolean = false;
  showResultsWithResume: boolean = false;
  filteredGenderOption: Array<any> = [];
  gender: string[] = [];
  functionNameForMoreResults: string;
  userSelectedData: any;
  showUserSelectedJobTitles: boolean = false;
  showUserSelectedPreferredSkills: boolean = false;
  showUserSelectedMandatorySkills: boolean = false;
  showUserSelectedLocations: boolean = false;
  showUserSelectedCompanies: boolean = false;
  showUserSelectedInstitutes: boolean = false;
  showUserSelectedGender: boolean = false;
  showUserSelectedEducationalDegrees: boolean = false;
  showUserSelectedIndustries: boolean = false;
  showUserSelectedSpokenLanguages: boolean = false;
  showUserSelectedProgrammingLanguages: boolean = false;
  showUserSelectedResumeOption: boolean = false;
  showFormError: boolean = false;
  jobtitlearraylist: Array<any> = [];
  skillsarraylist: Array<any> = [];
  industryarraylist: Array<any> = [];
  locationarraylist: Array<any> = [];
  companyarraylist: Array<any> = [];
  filteredJobTitleOptions: Array<any> = [];
  filteredSkillsOption: Array<any> = [];
  filteredIndustryOption: Array<any> = [];
  filteredLocationOption: Array<any> = [];
  filteredCompanyOption: Array<any> = [];
  jobtitle: string[] = [];
  industry: string[] = [];
  location: string[] = [];
  companies: string[] = [];
  preferredskills: string[] = [];
  mandatoryskills: string[] = [];
  recommendedjobtitle: any[] = [];
  recommendedskills: any[] = [];
  searchResults: any[] = [];
  startIndex: any;
  pageNumber: any = 1;
  searchResultNextPage: any;
  viewingResultsFirstTime: boolean = false;
  currentPageTypeBeforeGoingToHistoryPage: string;
  successMessage: string;
  errorMessage: string;
  jdAddedForParsing: boolean = false;
  fname: any;
  lname: any;
  candidatetoBeGrabbed: string[] = []
  selected: boolean
  isExtensioninstalled: boolean;
  @ViewChild('resultsSectionDiv') resultsSectionDiv: ElementRef;
  @ViewChild('grabModal') grabModal: TemplateRef<any>;
  @ViewChild('noCreditsJDParse') noCreditsJDParse: TemplateRef<any>;
  @ViewChild('noCreditsGrab') noCreditsGrab: TemplateRef<any>;
  @ViewChild('GrabInProgress') GrabInProgress: TemplateRef<any>;
  @ViewChild('GrabStarted') GrabStarted: TemplateRef<any>;
  talentpoolslist: any;
  talentpoolname: string;
  noTalentpoolError: boolean;
  totalcandidatesForGrab: any;
  totalcandidatesForGrabString: any;
  talentpoolFound: any;
  ErrorMessage: string;

  constructor(public searchtoolbox: SearchtoolboxService,
    private _localstorageservice: LocalStorageService,
    private modalService: NgbModal,
    private router: Router,
    private transactionservice: TransactionService,
    private candidateservice: CandidateService,
    private route: ActivatedRoute,
    private talentpoolservice: TalentpoolService) { }

  ngOnInit() {
    this.gethistory()
    setTimeout(()=>{
    let chromeid = localStorage.getItem('extensionID');
    let data;
    if (this.route.snapshot.queryParamMap.get('source') == 'extension' && chromeid) {
      window['chrome'].runtime.sendMessage(chromeid, { action: 'getSimilarCandidateResult' }, function (res) {
        data = res.similarCandidateData
        window.history.replaceState({}, '', `/searchtoolbox-v2`);
      });
    }
    setTimeout(() => {
      data = data ? data : this.candidateservice.getSimilarCandidateData()
      if (data && (data.jobtitles || data.locations || data.preferredskills)) {
        this.displayPlatformPage('Technical', 'LinkedIn')
        this.repeatSearch(data, 'similarcandidate')
        this.candidateservice.passSimilarCandidateData('')
      }
    }, 500)
    },500)
    

    if (!this._localstorageservice.getItem('userid')) {
      this.router.navigateByUrl('/login')
    }

    setTimeout(() => {
      this.sendMessagetoChrome()
    }, 1000)
  }

  ngAfterViewChecked() {
    if (this.viewingResultsFirstTime && this.showSearchResults && !this.showSearchHistoryPage && this.resultsSectionDiv) {
      this.resultsSectionDiv.nativeElement.scrollIntoView(true);
    }
    this.viewingResultsFirstTime = false;
  }

  sendMessagetoChrome() {
    let chromeid = localStorage.getItem('extensionID');
    let isExtensioninstalled
    if (chromeid) {
      try {
        window['chrome'].runtime.sendMessage(chromeid, { action: 'getSimilarCandidateResult' }, function (res) {
          if (res && res.similarCandidateData) {
            isExtensioninstalled = true
          }
        });
      } catch (error) {
        if (error) {
          isExtensioninstalled = false
        }
        console.error('Here is the error message', error);
      }

      setTimeout(() => {
        this.isExtensioninstalled = isExtensioninstalled
      }, 500)
    }
  }

  getAutoCompleteData(dropdowntype: any, searchedstring: any): Observable<any> {
    let data = {
      "dropdowntype": dropdowntype,
      "searchedstring": searchedstring
    }
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res: any) => {
      if (res.status == 'success') {
        subject.next(res.data);
      } else {
        subject.next([])
      }
    })
    return subject.asObservable();
  }

  addSuggestionChipOnClickingEnter(event, type) {
    if (event.target.value && event.key == "Enter" && event.target.value.toString().trim().toLowerCase().replace(/(&#34|&gt|script|;|&lt|<([^>]+)>)/ig, "").trim() != '') {
      event.target.value = event.target.value.toString().trim().toLowerCase().replace(/(&#34|&gt|script|;|&lt|<([^>]+)>)/ig, "")
      if (type == 'Job Title') {
        this.jobtitle.push(event.target.value);
        this.getRelatedData(type, event.target.value)
        event.target.value = ''
      } else if (type == 'Skill') {
        this.preferredskills.push(event.target.value);
        this.getRelatedData(type, event.target.value)
        event.target.value = ''
      } else if (type == 'Mandatory Skill') {
        this.mandatoryskills.push(event.target.value);
        this.getRelatedData('Skill', event.target.value)
        event.target.value = ''
      } else if (type == 'Location') {
        this.location.push(event.target.value);
        this.filteredLocationOption = []
        event.target.value = ''
      } else if (type == 'Company') {
        let companynameobj;
        companynameobj = {
          company_name: event.target.value
        }
        this.companies.push(companynameobj)
        this.filteredCompanyOption = []
        event.target.value = ''
      } else if (type == 'Institute') {
        this.institute.push(event.target.value);
        this.filteredInstituteOption = []
        event.target.value = ''
      } else if (type == 'SpokenLanguage') {
        this.spokenLanguage.push(event.target.value);
        this.filteredSpokenLanguageOption = []
        event.target.value = ''
      } else if (type == 'ProgrammingLanguage') {
        this.programmingLanguage.push(event.target.value);
        this.filteredProgrammingLanguageOption = []
        event.target.value = ''
      } else if (type == 'Industry') {
        this.industry.push(event.target.value);
        this.filteredIndustryOption = []
        event.target.value = ''
      } else if (type == 'EducationalDegree') {
        this.educationalDegree.push(event.target.value);
        this.filteredEducationalDegreeOption = []
        event.target.value = ''
      } else if (type == 'Gender') {
        this.gender.push(event.target.value);
        this.filteredGenderOption = []
        event.target.value = ''
      }
    }
  }

  selectAutoCompleteChip(event, type) {
    if (type == 'Job Title') {
      this.getRelatedData(type, event)
    } else if (type == 'Skill') {
      this.getRelatedData(type, event)
    }
  }

  addRecommendedSuggestionChip(i, value, type) {
    value = value.toString().trim().toLowerCase()
    if (type == "Job Title") {
      this.recommendedjobtitle.splice(i, 1);
      this.jobtitle.push(value);
      this.getRelatedData(type, value)
    } else if (type == "Skill") {
      this.recommendedskills.splice(i, 1);
      this.preferredskills.push(value);
      this.getRelatedData(type, value)
    } else if (type == "Mandatory Skill") {
      this.recommendedskills.splice(i, 1);
      this.mandatoryskills.push(value);
      this.getRelatedData('Skill', value)
    }
  }

  getRelatedData(type: string, value: string, action?) {
    let data = {
      searchparameter: type,
      searchedstring: value.toString().trim().toLowerCase().replace(/(&#34|&gt|script|;|&lt|<([^>]+)>)/ig, ""),
      selectedjobtitlesarray: this.jobtitle.filter((x) => { return x != value }),
      selectedskillsarray: [...this.preferredskills, ...this.mandatoryskills].filter((x) => { return x != value }),
      existingjobtitlessuggestionarray: this.recommendedjobtitle,
      existingskillssuggestionarray: this.recommendedskills,
      deselectedJobTitlesArray: this.deselectedJobTitlesArray,
      deselectedSkillsArray: this.deselectedSkillsArray
    }
    if (action == 'remove' && type == 'Job Title') {
      let selectedjob = data['selectedjobtitlesarray']
      data['searchedstring'] = selectedjob.length ? selectedjob[selectedjob.length - 1] : ''
      data['searchparameter'] = 'Job Title'
    } else if (action == 'remove' && type == 'Skill') {
      let selectedskill = data['selectedskillsarray']
      data['searchedstring'] = selectedskill.length ? selectedskill[selectedskill.length - 1] : ''
      data['searchparameter'] = 'Skill'
    }

    if (data.searchedstring.length) {
      this.searchtoolbox.recommendedData(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.recommendedjobtitle = res.data.related_job_titles
          this.recommendedskills = res.data.related_skills.filter((x) => x)
          this.filteredJobTitleOptions = []
          this.filteredSkillsOption = []
        }
        if (this.jdAddedForParsing) {
          this.jdAddedForParsing = false;
          this.displayAlertMessage('success', 'JD parsed successfully. Verify the parsed data and click on search.');
        }
      });
    }
  }

  returnToLandingPage() {
    this.showSearchHistoryPage = false;
    this.showSearchPlatformPage = false;
    this.resetAllFields();
    this.hideAndResetSearchResults();
  }

  displayPlatformPage(platformType: string, platformName?: string) {
    this.showSearchPlatformPage = true;
    this.selectedPlatformType = platformType;
    this.tabToShow = platformName;
  }

  showHistoryPage(currentPage: string) {
    this.currentPageTypeBeforeGoingToHistoryPage = currentPage;
    this.showSearchHistoryPage = true;
    this.gethistory()
  }

  gethistory(){
    let data = {
      "startindex": this.start,
      "usernumber": this._localstorageservice.getItem('usernumber')
    }
    this.searchtoolbox.fetchsearchtoolboxhistory(data).subscribe((res: any) => {
      if (res.status == 'success') {
        let response = res.data;
        this.searchToolboxHistory = response.searchhistoryrecords
        this.searchToolboxHistory.map(x => {
          x.updatedon = GlobalService.getDates(x.updatedon).text
          x.platformsaccessed = (x.platformsaccessed && x.searchtoolboxversion == "v2.0") ? x.platformsaccessed : 'LinkedIn'
          return x
        })
        this.totalHistoryRecordsCount = response.totalcount;

        this.total = this.totalHistoryRecordsCount
        if (this.start == 0) {
          if (this.end > this.total) {
            this.end = this.total
          }
          if (this.total == 0) {
            this.start = this.total;
            this.end = this.total
          } else if (this.total < 10) {
            this.end = this.total
          } else {
            this.end = this.start + 10;
          }
        }
      } else {
        console.log("Some error in loading history!");
      }
    })
  }
  pagination(type) {
    if (type == 'next') {
      this.start = this.start + 10
      this.end = this.start + 10
      if (this.end > this.total)
        this.end = this.total
      this.showHistoryPage('historyPage');
    } else if (type == 'prev') {
      this.start = this.start - 10
      this.end = this.start + 10
      this.showHistoryPage('historyPage');
    }
  }

  repeatSearch(data, type?) {
    this.resetAllFields();

    if (this.jdAddedForParsing) {
      this.preferredskills = (data.preferredskills && data.preferredskills.length) ? data.preferredskills : []
      this.mandatoryskills = (data.mandatoryskills && data.mandatoryskills.length) ? data.mandatoryskills : []
      this.educationalDegree = (data.educationaldegrees && data.educationaldegrees.length) ? data.educationaldegrees : []
      this.industry = (data.industries && data.industries.length) ? data.industries : []
      this.jobtitle = (data.jobtitles && data.jobtitles.length) ? data.jobtitles : []
      this.location = (data.locations && data.locations.length) ? data.locations : []
      this.spokenLanguage = (data.spokenlanguages && data.spokenlanguages.length) ? data.spokenlanguages : []
    } else {
      this.jobtitle = data.jobtitles ? data.jobtitles.split('; ') : []
      this.location = data.locations ? data.locations.split('; ') : []
      this.mandatoryskills = data.mandatoryskills ? data.mandatoryskills.split('; ') : []
      this.preferredskills = data.preferredskills ? data.preferredskills.split('; ') : []
      if (type && this.preferredskills && this.preferredskills.length) {
        this.preferredskills = this.preferredskills.slice(0, 5)
      }
      let companies = data.companies ? data.companies.split('; ') : []
      this.industry = data.industries ? _.pluck(data.industries, 'industry_name') : [];
      this.institute = data.schools ? data.schools.split('; ') : []
      this.spokenLanguage = data.spokenlanguages ? data.spokenlanguages.split('; ') : []
      this.programmingLanguage = data.programminglanguages ? data.programminglanguages.split('; ') : []
      this.educationalDegree = data.educationaldegrees ? data.educationaldegrees.split('; ') : []
      this.gender = data.gender ? data.gender.split('; ') : []
      if (companies.length > 0) {
        let companynameobj;
        companies.map(x => {
          companynameobj = {
            company_name: x
          }
          this.companies.push(companynameobj)
        })
      }
    }

    // To get related suggestions
    let value;
    let searchedParameter;
    if (this.jobtitle && this.jobtitle.length) {
      value = this.jobtitle[this.jobtitle.length - 1];
      searchedParameter = 'Job Title';
    } else if (this.preferredskills && this.preferredskills.length) {
      value = this.preferredskills[this.preferredskills.length - 1];
      searchedParameter = 'Skill';
    } else if (this.mandatoryskills && this.mandatoryskills.length) {
      value = this.mandatoryskills[this.mandatoryskills.length - 1];
      searchedParameter = 'Skill';
    }
    if (value) {
      this.getRelatedData(searchedParameter, value)
    } else if (this.jdAddedForParsing) {
      this.jdAddedForParsing = false;
      this.displayAlertMessage('success', 'JD parsed successfully. Verify the parsed data and search for talents.');
    }

    // Show LinkedIn platform page in default condition
    if (data.firstname || data.lastname) {
      this.selectedPlatformType = 'Person Search';
      this.fname = data.firstname
      this.lname = data.lastname
    } else if (data.searchtoolboxversion == 'v2.0') {
      this.tabToShow = data.platformsaccessed;
      this.selectedPlatformType = this.getPlatformType(this.tabToShow);
    } else if (data.searchtoolboxversion == 'v1.0') {
      this.tabToShow = 'LinkedIn';
      this.selectedPlatformType = this.getPlatformType(this.tabToShow);
    }
    this.showSearchHistoryPage = false;
    //  this.selectedPlatformType = this.getPlatformType(this.tabToShow);
    this.showSearchPlatformPage = true;

    if (type) {
      setTimeout(() => {
        this.googleCustomSearchAPI('initial', 'linkedInSearch')
      }, 1000)
    }
  }

  resetAllFields() {
    this.jobtitle = []
    this.location = []
    this.companies = []
    this.industry = []
    this.preferredskills = []
    this.mandatoryskills = []
    this.recommendedjobtitle = []
    this.recommendedskills = [];
    this.start = 0
    this.institute = []
    this.spokenLanguage = [];
    this.programmingLanguage = [];
    this.educationalDegree = [];
    this.gender = [];
    this.hideAndResetSearchResults();
    this.fname = null
    this.lname = null
  }

  getPlatformType(platformName: string) {
    let platformType;
    switch (true) {
      case (platformName == 'LinkedIn' || platformName == 'Xing' || platformName == 'Quora' || platformName == 'Twitter'):
        platformType = 'General';
        break;
      case (platformName == 'AngelList' || platformName == 'Kaggle' || platformName == 'GitHub' || platformName == 'Stack Overflow' || platformName == 'ResearchGate'):
        platformType = 'Technical';
        break;
      case (platformName == 'Behance' || platformName == 'Dribbble'):
        platformType = 'Creative';
        break;
      case (platformName == 'Doximity' || platformName == 'HealthProfs'):
        platformType = 'Health Care';
        break
      default:
        break;
    }
    return platformType;
  }

  searchAutoCompletedData(event, type) {
    if (event.query.trim().toLowerCase() != '') {
      if (type == 'Job Title') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('job titles', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredJobTitleOptions = res;
            }
          })
        }
      } else if (type == 'Skill') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('skills', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredSkillsOption = res;
            }
          })
        }
      } else if (type == 'Industry') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('industries', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredIndustryOption = _.pluck(res, 'industry_name');
            }
          })
        }
      } else if (type == 'Location') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('locations', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredLocationOption = res;
            }
          })
        }
      } else if (type == 'Company') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('companies', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredCompanyOption = res;
            }
          })
        }
      } else if (type == 'Institute') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('institutes', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredInstituteOption = res;
            }
          })
        }
      } else if (type == 'SpokenLanguage') {
        if (event.query.length > 0) {
          this.getAutoCompleteData('spoken languages', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredSpokenLanguageOption = res;
            }
          })
        }
      } else if (type == 'ProgrammingLanguage') {
        if (event.query.length > 0) {
          this.getAutoCompleteData('programming languages', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredProgrammingLanguageOption = res;
            }
          })
        }
      } else if (type == 'EducationalDegree') {
        if (event.query.length > 2) {
          this.getAutoCompleteData('educational degrees', event.query).subscribe((res) => {
            if (res && res.length) {
              this.filteredEducationalDegreeOption = res;
            }
          })
        }
      } else if (type == 'Gender') {
        if (event.query.length > 0) {
          this.filteredGenderOption = ['Male', 'Female'];
        }
      }
    }
  }

  googleCustomSearchAPI(searchType: string, functionName: string) {
    this.fname = this.fname ? this.fname.replace(/(&#34|&gt|script|;|&lt|<([^>]+)>)/ig, "") : null
    this.lname = this.lname ? this.lname.replace(/(&#34|&gt|script|;|&lt|<([^>]+)>)/ig, "") : null
    if(this.fname && this.fname.trim() == ''){
      this.fname = null
    }
    if(this.lname && this.lname.trim() == ''){
      this.lname = null
    }
    //to auto form chips if value are left in input box
    let inputjobtile = document.querySelectorAll('li.p-autocomplete-input-token') && document.querySelectorAll('li.p-autocomplete-input-token').length ? document.querySelectorAll('li.p-autocomplete-input-token') : []
    inputjobtile.forEach((x, i) => {
      if (document.querySelectorAll('li.p-autocomplete-input-token') && document.querySelectorAll('li.p-autocomplete-input-token')[i].children[0]) {
        document.querySelectorAll('li.p-autocomplete-input-token')[i].children[0].dispatchEvent(new KeyboardEvent('keyup', {
          key: 'Enter',
        }))
      }
    })

    if (searchType == 'initial') {
      this.hideAndResetSearchResults();
    }
    // Validation: Minimum 1 preferred skill required
    if (this.preferredskills.length || (this.selectedPlatformType == 'Person Search' && this.fname && this.fname.replace(/(&#34|&gt|script|;|&lt|<([^>]+)>)/ig, "").trim() != '' && this.lname && this.lname.replace(/(&#34|&gt|script|;|&lt|<([^>]+)>)/ig, "").trim() != '')) {
      this.showFormError = false;

      this.userSelectedData = {};
      if (functionName) {
        this.functionNameForMoreResults = functionName
      }

      if (searchType == 'initial') {
        this.startIndex = 1
      } else if (searchType == 'nextPage' && (!functionName && this.functionNameForMoreResults)) {
        this.startIndex = this.startIndex + 10;
      }

      this.userSelectedData = {
        startindex: this.startIndex,
        usernumber: this._localstorageservice.getItem('usernumber')
      };
      if (this.jobtitle.length) {
        this.userSelectedData['jobtitles'] = this.jobtitle;
      }
      if (this.preferredskills.length) {
        this.userSelectedData['preferredskills'] = this.preferredskills;
      }
      if (this.mandatoryskills.length) {
        this.userSelectedData['mandatoryskills'] = this.mandatoryskills;
      }
      if (this.location.length) {
        this.userSelectedData['locations'] = this.location;
      }
      if (this.companies.length) {
        this.userSelectedData['companies'] = _.pluck(this.companies, 'company_name');
      }
      if (this.spokenLanguage.length) {
        this.userSelectedData['spokenlanguages'] = this.spokenLanguage;
      }
      if (this.institute.length) {
        this.userSelectedData['schools'] = this.institute;
      }
      if (this.industry.length) {
        this.userSelectedData['industries'] = this.industry;
      }
      if (this.programmingLanguage.length) {
        this.userSelectedData['programminglanguages'] = this.programmingLanguage;
      }
      if (this.educationalDegree.length) {
        this.userSelectedData['educationaldegrees'] = this.educationalDegree;
      }
      if (this.showResultsWithResume) {
        this.userSelectedData['resumecheckbox'] = 1;
      }
      if (this.gender.length) {
        this.userSelectedData['gender'] = this.gender;
      }
      if (this.selectedPlatformType == 'Person Search') {
        this.userSelectedData['firstname'] = this.fname;
        this.userSelectedData['lastname'] = this.lname;
      }
      this.userSelectedData.calledviawebapp = true
      this.searchtoolbox[this.functionNameForMoreResults](this.userSelectedData).subscribe((res: any) => {
        if (res.status == 'success') {
          // let tempresults = []
          this.searchResults = res.data.searchResults
          this.searchResultNextPage = res.data.nextSearchPagePresent
          this.totalSearchResultsCount = res.data.totalResults
          // if(this.totalSearchResultsCount > 0){
          //   this.searchResults = [...this.searchResults,...tempresults]
          // }

          // Show user selected options based on current platform
          if (this.userSelectedData.jobtitles && this.tabToShow != 'GitHub') {
            this.showUserSelectedJobTitles = true;
          }
          if (this.userSelectedData.preferredskills) {
            this.showUserSelectedPreferredSkills = true;
          }
          if (this.userSelectedData.mandatoryskills) {
            this.showUserSelectedMandatorySkills = true;
          }
          if (this.userSelectedData.locations && this.selectedPlatformType != 'Doximity' && this.selectedPlatformType != 'HealthProfs') {
            this.showUserSelectedLocations = true;
          }
          if (this.userSelectedData.companies && (this.tabToShow == 'LinkedIn' || this.selectedPlatformType == 'General' || this.selectedPlatformType == 'Person Search')) {
            this.showUserSelectedCompanies = true;
          }
          if (this.userSelectedData.spokenlanguages && this.tabToShow == 'LinkedIn') {
            this.showUserSelectedSpokenLanguages = true;
          }
          if (this.userSelectedData.schools && (this.tabToShow == 'LinkedIn' || this.tabToShow == 'ResearchGate' || this.selectedPlatformType == 'Person Search')) {
            this.showUserSelectedInstitutes = true;
          }
          if (this.userSelectedData.industries && (this.tabToShow == 'LinkedIn' || this.tabToShow == 'Xing')) {
            this.showUserSelectedIndustries = true;
          }
          if (this.userSelectedData.programminglanguages && this.tabToShow == 'GitHub') {
            this.showUserSelectedProgrammingLanguages = true;
          }
          if (this.userSelectedData.educationaldegrees && (this.tabToShow == 'ResearchGate' || this.tabToShow == 'Doximity' || this.selectedPlatformType == 'Person Search')) {
            this.showUserSelectedEducationalDegrees = true;
          }
          if (this.userSelectedData.resumecheckbox && this.userSelectedData.resumecheckbox == 1 && this.tabToShow == 'Behance') {
            this.showUserSelectedResumeOption = true;
          }
          if (this.userSelectedData.gender && this.tabToShow == 'Doximity') {
            this.showUserSelectedGender = true;
          }

          this.showSearchResults = true;
          this.viewingResultsFirstTime = true;


          //- Clevertap Search event
          let ctObj = {
            "Job title": this.userSelectedData['jobtitles'] ? this.userSelectedData['jobtitles'].join(", ") : "",
            "Preferred Skills": this.userSelectedData['preferredskills'] ? this.userSelectedData['preferredskills'].join(", ") : "",
            "Mandatory Skills": this.userSelectedData['mandatoryskills'] ? this.userSelectedData['mandatoryskills'].join(", ") : "",
            "Locations": this.userSelectedData['locations'] ? this.userSelectedData['locations'].join(", ") : "",
            "Target Companies": this.userSelectedData['companies'] ? this.userSelectedData['companies'].join(", ") : "",
            "Industries": this.userSelectedData['industries'] ? this.userSelectedData['industries'].join(", ") : "",
            "Institutes": this.userSelectedData['schools'] ? this.userSelectedData['schools'].join(", ") : "",
            "Spoken Languages": this.userSelectedData['spokenlanguages'] ? this.userSelectedData['spokenlanguages'].join(", ") : "",
            "Page": this.pageNumber - 1,
            "Platform": this.tabToShow,
          }
          this.cleverTapEvent("Search", ctObj);
        }

        if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length) {
          this.searchResults = this.searchResults.map((x: any) => {
            let res = x
            let isSelected = this.candidatetoBeGrabbed.filter((y: any) => { return y == res.link })
            if (isSelected && isSelected.length) {
              res.selected = true
            }
            return res
          })
        }
      })
    } else {
      this.showFormError = true;
    }
  }

  showResumeCheckbox(event) {
    this.showResultsWithResume = event.target.checked;
  }

  removeSelectedChip(event, type) {
    if (type == 'Job Title' && this.deselectedJobTitlesArray.indexOf(event) == -1) {
      this.deselectedJobTitlesArray.push(event)
      this.getRelatedData(type, event, 'remove')
    } else if (type == 'Skill' && this.deselectedSkillsArray.indexOf(event) == -1) {
      this.deselectedSkillsArray.push(event)
      this.getRelatedData(type, event, 'remove')
    }
  }

  updateTabToShow(platformType: string, platformName: string) {
    this.tabToShow = platformName;
    this.selectedPlatformType = platformType;
    this.hideAndResetSearchResults();
  }

  hideAndResetSearchResults() {
    this.showSearchResults = false;
    this.searchResults = [];
    this.searchResultNextPage = undefined;
    this.totalSearchResultsCount = undefined;
    this.showFormError = false;
    this.showUserSelectedJobTitles = false;
    this.showUserSelectedPreferredSkills = false;
    this.showUserSelectedMandatorySkills = false;
    this.showUserSelectedLocations = false;
    this.showUserSelectedCompanies = false;
    this.showUserSelectedInstitutes = false;
    this.showUserSelectedGender = false;
    this.showUserSelectedEducationalDegrees = false;
    this.showUserSelectedIndustries = false;
    this.showUserSelectedSpokenLanguages = false;
    this.showUserSelectedProgrammingLanguages = false;
    this.showUserSelectedResumeOption = false;
  }

  goBackFromHistoryPage() {
    this.showSearchHistoryPage = false;
    if (this.currentPageTypeBeforeGoingToHistoryPage == 'platformPage') {
      this.showSearchPlatformPage = true;
    } else if (this.currentPageTypeBeforeGoingToHistoryPage == 'landingPage') {
      this.showSearchPlatformPage = false;
      this.resetAllFields();
      this.hideAndResetSearchResults();
    }
  }

  route2store() {
    window.open('https://chrome.google.com/webstore/detail/webbtree-chrome-extension/jlmhleoipeloancgdilegcelojacmpcm', "_blank");
  }

  addJobDescription() {
    if (this._localstorageservice.getItem('jdcredits') > 0) {
      const modalRef = this.modalService.open(JobDescriptionModalComponent, { size: 'lg' as 'lg', centered: true });
      modalRef.componentInstance.parsedJDData.subscribe((parsedResponse) => {
        if (parsedResponse && parsedResponse.status && parsedResponse.status == 'success') {
          if (parsedResponse.data.searchParameterFoundInParsedData) {
            this.jdAddedForParsing = true;
            this.repeatSearch(parsedResponse.data);
          } else {
            this.resetAllFields();
            this.jdAddedForParsing = false;
            this.displayAlertMessage('success', 'JD parsed successfully but no search parameters found. Try with another JD.');
          }
          this.fetchcredits()
        } else if (parsedResponse && parsedResponse.status && parsedResponse.status == 'failure' && parsedResponse.message == 'insufficient credits') {
          this.modalService.open(this.noCreditsJDParse, { windowClass: "myCustomModalClass", centered: true });
          this.sendmailexpiry('JD Parsing credits')
        } else {
          this.resetAllFields();
          this.jdAddedForParsing = false;
          this.displayAlertMessage('error', 'Some issue in parsing the JD. Try with a different JD.');
        }
      })
    } else {
      this.modalService.open(this.noCreditsJDParse, { windowClass: "myCustomModalClass", centered: true });
      this.sendmailexpiry('JD Parsing credits')
    }

  }

  displayAlertMessage(messageType: string, message: string) {
    if (messageType == 'success') {
      this.successMessage = message;
    } else {
      this.errorMessage = message;
    }
    setTimeout(() => {
      this.successMessage = '';
      this.errorMessage = '';
    }, 5000);
  }

  route2pricing() {
    this.modalService.dismissAll()
    this.router.navigateByUrl('/subscription/pricing')
  }

  fetchcredits() {
    this.transactionservice.fetchcurrentplandetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        this._localstorageservice.setItem('jdcredits', res.data.balancejdparsingcredits)
        this._localstorageservice.setItem('tpcredits', res.data.balancetalentpipelinecredits)
        this._localstorageservice.setItem('cecredits', res.data.balancecontactenrichmentcredits)
        this._localstorageservice.setItem('secredits', res.data.balancesmartemailcredits)
      }
    })
  }

  sendmailexpiry(type) {
    let data = {
      expiredmetric: type
    }
    this.transactionservice.sendcreditexpirymail(data).subscribe()
  }


  getAllTalentpool() {
    this.talentpoolservice.getTalentpoolList(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        if (this.talentpoolname != undefined && this.talentpoolname != null) {
          this.talentpoolslist = res.data.talentpools.filter((x) => { return x.name.toLowerCase().includes(this.talentpoolname.toLowerCase()) });
          this.talentpoolFound = this.talentpoolslist.find(x => (x.name == this.talentpoolname));
        } else {
          this.talentpoolslist = res.data.talentpools
        }
        if (this.talentpoolFound == undefined && this.talentpoolname && this.talentpoolname.trim() != '') {
          this.noTalentpoolError = true
        } else {
          this.noTalentpoolError = false
        }
      }
    })
  }

  selectCandidate(e, data) {
    if (e.target.checked) {
      if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length < 20) {
        this.candidatetoBeGrabbed.push(data.link)
        data.selected = true
      } else {
        data.selected = false
        e.target.checked = false;
      }
    } else {
      data.selected = false
      e.target.checked = false;
      this.candidatetoBeGrabbed = this.candidatetoBeGrabbed.filter(x => x != data.link)
    }
    this.totalcandidatesForGrabString = "Total " + this.candidatetoBeGrabbed.length + " candidates selected"
  }

  openGrabModal() {
    if (this._localstorageservice.getItem('totalgrabcandidate') > 0) {
      this.modalService.open(this.GrabInProgress, { windowClass: "myCustomModalClass", centered: true });
    } else {
      this.modalService.open(this.grabModal, { windowClass: "myCustomModalClass", centered: true });
    }
  }

  doBulkExtraction() {
    let data = {}
    let platform = this.tabToShow == 'LinkedIn' ? 'linkedin' : this.tabToShow == 'GitHub' ? 'github' : this.tabToShow == 'Stack Overflow' ? 'stackoverflow' : null;
    data['platform'] = platform;
    this.searchtoolbox.bulkextractionstatus().subscribe((res: any) => {
      if (res.bulkextractioninprogress == true) {
        this.modalService.open(this.GrabInProgress, { windowClass: "myCustomModalClass", centered: true });
      } else {
        if (this.talentpoolFound && this.talentpoolFound.talentpoolnumber) {
          data['talentpoolnumber'] = this.talentpoolFound.talentpoolnumber
        }

        if (this.candidatetoBeGrabbed && this.candidatetoBeGrabbed.length) {
          data['profileurlsarray'] = this.candidatetoBeGrabbed
          this.BulkExtractCandidate(data)
        } else if (this.totalcandidatesForGrab > 20) {
          this.ErrorMessage = "Only 20 candidates are allowed"
        } else if (this.totalcandidatesForGrab) {
          if (this.totalcandidatesForGrab > 10) {
            this.userSelectedData.startindex = 11
            this.searchtoolbox.linkedInSearch(this.userSelectedData).subscribe((res: any) => {
              if (res.status == 'success') {
                let tempresults = []
                tempresults = res.data.searchResults
                if (res.data.totalResults > 0) {
                  let searchResults = [...this.searchResults, ...tempresults]
                  data['profileurlsarray'] = searchResults.slice(0, this.totalcandidatesForGrab).map(x => { return x.link })
                  this.BulkExtractCandidate(data)
                }
              }
            })
          } else {
            data['profileurlsarray'] = this.searchResults.slice(0, this.totalcandidatesForGrab).map(x => { return x.link })
            this.BulkExtractCandidate(data)
          }
        } else if (this.candidatetoBeGrabbed.length == 0 && !this.totalcandidatesForGrab) {
          this.ErrorMessage = "Please Enter no of candidates"
        }
      }
    })
  }

  BulkExtractCandidate(data) {
    if (data.profileurlsarray && data.profileurlsarray.length && !this.noTalentpoolError) {
      this.ErrorMessage = ''
      this.searchtoolbox.bulkgrab(data).subscribe((res: any) => {
        if (res.message == 'insufficient credits') {
          this.modalService.open(this.noCreditsGrab, { windowClass: "myCustomModalClass", centered: true });
          this.sendmailexpiry('Bulk Grabbing')
        } else if (res.status == 'success') {
          this.searchResults = this.searchResults.map((x: any) => {
            let res = x
            x.selected = false
            return res;
          })
          this.selected = false
          this.searchtoolbox.passGrabCandidateData(data)
          this.candidatetoBeGrabbed = []
          this.talentpoolFound = null
          this.modalService.open(this.GrabStarted, { windowClass: "myCustomModalClass", centered: true });
        } else {
          this.modalService.dismissAll()
          this.searchResults = this.searchResults.map((x: any) => {
            let res = x
            x.selected = false
            return res;
          })
          this.selected = false
          this.candidatetoBeGrabbed = []
          this.talentpoolFound = null
          this.errorMessage = res.message;
          setTimeout(() => this.errorMessage = '', 5000);
        }
      })
    }

  }

  setPage(index) {
    let start = (index - 1) * 20
    this.startIndex = start + 1
    this.selected = false
    this.pageNumber = index
    this.googleCustomSearchAPI('', this.functionNameForMoreResults)
  }

  selectAll(e) {
    if (e.target.checked && this.candidatetoBeGrabbed.length < 20) {
      this.searchResults.forEach((x: any) => {
        let event = {
          target: {
            checked: true
          }
        }
        this.selectCandidate(event, x)
      })
    } else {
      this.selected = false
      e.target.checked = false;
      this.searchResults.forEach((x: any) => {
        let event = {
          target: {
            checked: false
          }
        }
        this.selectCandidate(event, x)
      })
    }
  }

  routeURL(type) {
    window.open('https://chrome.google.com/webstore/detail/webbtree-chrome-extension/jlmhleoipeloancgdilegcelojacmpcm?utm_source=gmail', "_blank")
  }

  dismissBulkModal() {
    this.modalService.dismissAll()
    this.talentpoolFound = null
    this.noTalentpoolError = false
    this.talentpoolname = null
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event", data);
  }

  candidateCT(index) {
    console.log("candidate clicked::", index)
    //- Clevertap Search candidate clicked event
    let ctObj = {
      "Job title": this.userSelectedData['jobtitles'] ? this.userSelectedData['jobtitles'].join(", ") : "",
      "Preferred Skills": this.userSelectedData['preferredskills'] ? this.userSelectedData['preferredskills'].join(", ") : "",
      "Mandatory Skills": this.userSelectedData['mandatoryskills'] ? this.userSelectedData['mandatoryskills'].join(", ") : "",
      "Locations": this.userSelectedData['locations'] ? this.userSelectedData['locations'].join(", ") : "",
      "Target Companies": this.userSelectedData['companies'] ? this.userSelectedData['companies'].join(", ") : "",
      "Industries": this.userSelectedData['industries'] ? this.userSelectedData['industries'].join(", ") : "",
      "Institutes": this.userSelectedData['schools'] ? this.userSelectedData['schools'].join(", ") : "",
      "Spoken Languages": this.userSelectedData['spokenlanguages'] ? this.userSelectedData['spokenlanguages'].join(", ") : "",
      "Page": this.pageNumber - 1,
      "Platform": this.tabToShow,
      "Index": index
    }
    this.cleverTapEvent("Search candidate clicked", ctObj);
  }
}
